/* ARX premium: icon rail, bundle finder, quote prefill, PDP logo path, sticky bar. No dependencies. */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var money = function (cents) {
    return '£' + (cents / 100).toFixed(cents % 100 ? 2 : 0);
  };

  /* ---------- icon rail ---------- */
  function initRail(root) {
    var track = root.querySelector('[data-rail-track]');
    if (!track) return;
    var prev = root.querySelector('[data-rail-prev]');
    var next = root.querySelector('[data-rail-next]');
    var stopped = false; // set true on any real user interaction, never resumes
    var hovering = false, focused = false, visible = true, timer = null;

    function step() {
      var tile = track.querySelector('.arx-rail__tile');
      return tile ? tile.getBoundingClientRect().width + 14 : 200;
    }
    function edges() {
      var max = track.scrollWidth - track.clientWidth - 2;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max;
    }
    function userTookOver() { stopped = true; clearInterval(timer); }

    if (prev) prev.addEventListener('click', function () { userTookOver(); track.scrollBy({ left: -step() * 2, behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { userTookOver(); track.scrollBy({ left: step() * 2, behavior: 'smooth' }); });
    track.addEventListener('scroll', edges, { passive: true });
    window.addEventListener('resize', edges);
    edges();

    /* touch / wheel / keyboard = user is driving */
    ['touchstart', 'wheel', 'keydown'].forEach(function (ev) { track.addEventListener(ev, userTookOver, { passive: true }); });

    /* mouse drag with momentum (touch uses native scroll + CSS snap momentum) */
    var down = false, startX = 0, startLeft = 0, lastX = 0, lastT = 0, vel = 0, moved = false, raf = 0;
    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      userTookOver(); cancelAnimationFrame(raf);
      down = true; moved = false; startX = lastX = e.clientX; startLeft = track.scrollLeft; lastT = performance.now(); vel = 0;
    });
    window.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (!moved && Math.abs(dx) > 5) { moved = true; track.classList.add('is-dragging'); }
      if (!moved) return;
      track.scrollLeft = startLeft - dx;
      var now = performance.now();
      vel = (lastX - e.clientX) / Math.max(1, now - lastT);
      lastX = e.clientX; lastT = now;
    });
    window.addEventListener('pointerup', function () {
      if (!down) return;
      down = false;
      if (!moved) return;
      var v = vel * 16;
      (function glide() {
        if (Math.abs(v) < 0.5) { track.classList.remove('is-dragging'); return; }
        track.scrollLeft += v; v *= 0.94; raf = requestAnimationFrame(glide);
      })();
    });

    /* gentle auto-advance */
    if (root.hasAttribute('data-autoplay') && !reduce) {
      var every = parseInt(root.getAttribute('data-autoplay'), 10) || 4500;
      var tick = function () {
        if (stopped || hovering || focused || !visible || document.hidden) return;
        var max = track.scrollWidth - track.clientWidth - 2;
        if (track.scrollLeft >= max) track.scrollTo({ left: 0, behavior: 'smooth' });
        else track.scrollBy({ left: step(), behavior: 'smooth' });
      };
      timer = setInterval(tick, every);
      root.addEventListener('mouseenter', function () { hovering = true; });
      root.addEventListener('mouseleave', function () { hovering = false; });
      root.addEventListener('focusin', function () { focused = true; });
      root.addEventListener('focusout', function () { focused = false; });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (en) { visible = en[0].isIntersecting; }).observe(root);
      }
    }
  }

  /* ---------- bundle team-size finder ---------- */
  function initFinder(root) {
    var cards = [].slice.call(document.querySelectorAll('[data-arx-bundle]')).map(function (el) {
      return {
        el: el, people: parseInt(el.dataset.people, 10) || 1, price: parseInt(el.dataset.price, 10) || 0,
        url: el.dataset.url, title: el.dataset.title, img: el.dataset.img
      };
    }).filter(function (b) { return b.price > 0; });
    var reco = root.querySelector('[data-arx-reco]');
    var chips = [].slice.call(root.querySelectorAll('[data-size]'));
    if (!cards.length || !reco) return;

    function best(size) {
      var opts = [];
      cards.forEach(function (b) {
        if (b.people >= size) opts.push({ b: b, qty: 1, total: b.price, over: b.people - size });
        var qty = Math.ceil(size / b.people);
        if (b.people < size && qty <= 5) opts.push({ b: b, qty: qty, total: b.price * qty, over: b.people * qty - size });
      });
      if (!opts.length) { // bigger team than any bundle: take the largest and flag it
        var big = cards.slice().sort(function (a, c) { return c.people - a.people; })[0];
        return { b: big, qty: Math.ceil(size / big.people), total: big.price * Math.ceil(size / big.people), over: 0, large: true };
      }
      /* fewest wasted garments first, then lowest per-person cost */
      opts.sort(function (a, c) {
        var ra = a.over / (a.b.people * a.qty), rc = c.over / (c.b.people * c.qty);
        if (Math.abs(ra - rc) > 0.25) return ra - rc;
        return a.total / size - c.total / size;
      });
      return opts[0];
    }
    function select(chip) {
      chips.forEach(function (c) { c.setAttribute('aria-pressed', c === chip ? 'true' : 'false'); });
      var size = parseInt(chip.dataset.size, 10);
      var r = best(size);
      cards.forEach(function (b) {
        b.el.classList.toggle('is-best', b === r.b);
        var tag = b.el.querySelector('.arx-badge--best');
        if (tag) tag.hidden = b !== r.b;
      });
      reco.querySelector('[data-reco-img]').src = r.b.img || '';
      reco.querySelector('[data-reco-img]').hidden = !r.b.img;
      reco.querySelector('[data-reco-title]').textContent = (r.qty > 1 ? r.qty + ' x ' : '') + r.b.title;
      var pp = money(Math.round(r.total / Math.max(size, 1)));
      var why = r.large
        ? 'Biggest team pack we have. For ' + chip.textContent.trim() + ' people we will build a bigger order, ask for a quote.'
        : (r.qty > 1 ? 'Covers ' + size + ' people with ' + r.qty + ' packs.' : 'Covers up to ' + r.b.people + (r.b.people === 1 ? ' person.' : ' people.')) + ' About ' + pp + ' per person.';
      reco.querySelector('[data-reco-why]').textContent = why + ' Total ' + money(r.total) + '.';
      reco.querySelector('[data-reco-link]').href = r.b.url;
      reco.classList.add('is-on');
      try { sessionStorage.setItem('arx_team_size', chip.dataset.size); } catch (e) {}
    }
    chips.forEach(function (c) { c.addEventListener('click', function () { select(c); }); });
    try {
      var saved = sessionStorage.getItem('arx_team_size');
      var m = saved && chips.filter(function (c) { return c.dataset.size === saved; })[0];
      if (m) select(m);
    } catch (e) {}
  }

  /* ---------- quote forms: CRM hand-off ---------- */
  function initQuote(form) {
    var portal = form.dataset.hsPortal, hsForm = form.dataset.hsForm, hook = form.dataset.webhook;
    var params = new URLSearchParams(location.search);
    ['quote_product', 'quote_product_url', 'quote_variant', 'quote_collection', 'quote_collection_url', 'quote_team_size', 'quote_source'].forEach(function (k) {
      var el = form.querySelector('[name="contact[' + k + ']"]');
      if (el && params.get(k) && !el.value) el.value = params.get(k);
    });
    var teamSel = form.querySelector('[name="contact[team_size]"]');
    if (teamSel && !teamSel.value) {
      try { var s = sessionStorage.getItem('arx_team_size'); if (s) { [].some.call(teamSel.options, function (o) { if (o.dataset.size === s) { teamSel.value = o.value; return true; } }); } } catch (e) {}
    }
    form.addEventListener('submit', function () {
      var data = {};
      [].forEach.call(form.elements, function (el) { if (el.name && el.value && el.type !== 'submit') data[el.name.replace(/^contact\[|\]$/g, '')] = el.value; });
      data.page_url = location.href;
      if (hook) { try { fetch(hook, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(data), keepalive: true, mode: 'no-cors' }); } catch (e) {} }
      if (portal && hsForm) {
        var fields = Object.keys(data).map(function (k) { return { name: k, value: data[k] }; });
        var hutk = (document.cookie.match(/hubspotutk=([^;]+)/) || [])[1];
        try {
          fetch('https://api.hsforms.com/submissions/v3/integration/submit/' + portal + '/' + hsForm, {
            method: 'POST', headers: { 'Content-Type': 'application/json' }, keepalive: true,
            body: JSON.stringify({ fields: fields, context: { hutk: hutk, pageUri: location.href, pageName: document.title } })
          });
        } catch (e) {}
      }
    });
  }

  /* ---------- PDP: logo path, delivery card, sticky bar ---------- */
  function initPdp() {
    var logo = document.querySelector('[data-arx-logo]');
    var branded = false;
    function applyBranding() {
      document.querySelectorAll('[data-lead-plain]').forEach(function (e) { e.hidden = branded; });
      document.querySelectorAll('[data-lead-branded]').forEach(function (e) { e.hidden = !branded; });
      var lbl = document.querySelector('[data-sticky-label]');
      if (lbl) lbl.textContent = branded ? 'Add with logo' : 'Add to basket';
    }
    if (logo) {
      var paths = logo.querySelector('[data-logo-paths]');
      var update = function () {
        var v = logo.querySelector('input[name="properties[Branding]"]:checked');
        branded = !!v && v.value === 'Add your logo';
        paths.classList.toggle('is-on', branded);
        paths.querySelectorAll('input').forEach(function (i) { i.disabled = !branded; });
        var ref = paths.querySelector('[data-logo-ref]');
        var up = paths.querySelector('input[value="Upload now"]');
        if (ref) ref.hidden = !(up && up.checked);
        applyBranding();
      };
      [].forEach.call(logo.querySelectorAll('input[type=radio]'), function (r) { r.addEventListener('change', update); });
      update();
    }
    var sticky = document.querySelector('[data-arx-sticky]');
    if (sticky) {
      var btn = document.querySelector('product-form button[type="submit"], .product-form__submit');
      var src = function () { return document.querySelector('.product__info-container .price-item--sale, .product__info-container .price-item--regular'); };
      var sync = function () { var s = src(); var t = sticky.querySelector('[data-sticky-price]'); if (s && t) t.textContent = s.textContent.trim(); };
      sync();
      var info = document.querySelector('.product__info-container');
      if (info && 'MutationObserver' in window) new MutationObserver(sync).observe(info, { childList: true, subtree: true, characterData: true });
      if (btn && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (en) { sticky.classList.toggle('is-on', !en[0].isIntersecting); }).observe(btn);
      }
      sticky.querySelector('button').addEventListener('click', function () {
        if (btn) { btn.scrollIntoView({ behavior: 'smooth', block: 'center' }); setTimeout(function () { btn.click(); }, 350); }
      });
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-arx-rail]').forEach(initRail);
    document.querySelectorAll('[data-arx-finder]').forEach(initFinder);
    document.querySelectorAll('[data-arx-quote]').forEach(initQuote);
    document.querySelectorAll('[data-arx-autosubmit]').forEach(function (f) { f.addEventListener('change', function () { f.submit(); }); });
    initPdp();
  });
})();